import * as auth from 'core/store/auth.duck';

// Plain function (NOT a hook): it runs from route `render` props where React
// Router's class-based <Route> is rendering, so calling useDispatch here throws
// React error #321 and blanks the app. The caller must provide `dispatch`.
export function setLoginContext(queryParams, dispatch) {
  const urlParams = new URLSearchParams(queryParams);
  const loginContext = urlParams.get('loginContext');
  dispatch(auth.actions.updateLoginContext(loginContext));
}
